import { ContentfulObjAnalytics, ContentType } from '../../types'
import { isObject } from '@utils/type-guards/is-object'

export const isObjAnalytics = (obj: unknown): obj is ContentfulObjAnalytics => {
  return isObject(obj) && typeof obj.CONTENT_TYPE === 'string' && obj.CONTENT_TYPE === ContentType.OBJ_ANALYTICS
}
